import { createT } from "@/app/[lang]/_utils/create-t";
import Image from "@/components/Image";
import type { Lang } from "@/langs";
import { Button } from "@borderless/ui/components/button";
import { cn } from "@borderless/ui/lib/utils";
import { RefreshCwIcon, Undo2 } from "lucide-react";
import { Nunito } from "next/font/google";
import { type FC } from "react";
import dictionary from "./t.json";

const t = createT(dictionary);

const nunito = Nunito({
  subsets: ["latin"],
  variable: "--font-nunito",
});

export const GlobalErrorDisplay: FC<{
  lang?: Lang;
  reset: () => void;
}> = (props) => {
  return (
    <main
      className={cn(
        nunito.variable,
        "font-sans",
        "flex min-h-dvh w-screen items-center justify-center p-(--main-padding)",
      )}
    >
      <div className="mx-auto max-w-2xl space-y-4 text-center">
        <h1 className="font-(family-name:--font-caprasimo) text-2xl md:text-4xl">
          Error
        </h1>
        <Image
          src="/images/error.webp"
          alt="Error"
          width={320}
          height={320}
          className="mx-auto size-40 md:size-80"
        />
        <p className="text-lg">
          {t(
            "We're sorry, but something went wrong. Please try again later or contact support at [hello@borderless.so](mailto:hello@borderless.so) if the problem persists.",
            props.lang ?? "en",
          )}
        </p>
        <div className="flex items-center justify-center gap-4">
          <Button
            onClick={() => {
              window.history.back();
            }}
            variant="outline"
          >
            <Undo2 className="h-8 w-8" />
          </Button>
          <Button
            onClick={() => {
              props.reset();
              window.location.reload();
            }}
            variant="outline"
          >
            <RefreshCwIcon className="h-8 w-8" />
          </Button>
        </div>
      </div>
    </main>
  );
};
